import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'overallPerformance',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',

  // compareSelectedYearForYTD: '',
  // compareSelectedQuarterForYTD: '',
  overallPerformanceRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareOverallPerformanceRangeTableOne: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  overallPerformanceYTDRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareOverallPerformanceRangeYTD: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const overallPerformanceSlice = createSlice({
  name: 'overallPerformance',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setOverallPerformanceRange: (state, action) => ({
      ...state,
      overallPerformanceRange: action.payload,
    }),
    setOverallPerformanceYTDRange: (state, action) => ({
      ...state,
      overallPerformanceYTDRange: action.payload,
    }),
    setCompareOverallPerformanceRangeForTableOne: (state, action) => ({
      ...state,
      compareOverallPerformanceRangeTableOne: action.payload,
    }),
    setCompareOverallPerformanceRangeYTD: (state, action) => ({
      ...state,
      compareOverallPerformanceRangeYTD: action.payload,
    }),
  },
});

export const overallPerformanceActions = overallPerformanceSlice.actions;

export default overallPerformanceSlice.reducer;
